import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const r = await login(email, password);
      nav(r.role === "admin" ? "/admin" : "/account");
    } catch {} finally { setBusy(false); }
  };

  return (
    <div className="ja-container py-24 max-w-md" data-testid="login-page">
      <div className="text-center mb-12">
        <p className="ja-overline">Welcome Back</p>
        <h1 className="ja-serif text-5xl mt-3 tracking-tight">Sign In</h1>
      </div>
      <form onSubmit={submit} className="space-y-8">
        <input type="email" required placeholder="Email Address" className="ja-input" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
        <input type="password" required placeholder="Password" className="ja-input" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
        <button type="submit" disabled={busy} className="ja-btn w-full" data-testid="login-submit">{busy ? "Signing in…" : "Sign In"}</button>
      </form>
      <p className="text-center text-sm mt-10" style={{ color: "var(--ja-muted)" }}>
        New here? <Link to="/register" className="underline" data-testid="link-register">Create an account</Link>
      </p>
    </div>
  );
}
